import React, {useEffect, useMemo, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {updateConfirmationRes} from '../../../../../../redux/ScheduleSlice';
import HugimCancellation from "./HugimCancellation";
import {DEFAULTS} from "../../../../../../services/ConstHelper";
import usePermissions from "../../../../../../services/Permissions";

const UpdateParticipants = (props) => {
    const { values, setFieldValue, isSingle, hideReason, isHug, isAppointment } = props;
    const scheduleCancelReasons = useSelector(state => state.box.box?.scheduleCancelReasons?.filter(reason => reason.active));
    const defaults = useSelector(state => state.box.box?.settings?.[DEFAULTS]);
    const [defaultValues, setDefaultValues] = useState(null);
    const dispatch = useDispatch();
    const {has} = usePermissions()
    const allowReasonSelect = useMemo(() => !hideReason && (isHug || has('scheduleCancelReason')), [isHug, hideReason]);

    useEffect(() => {
        if(!defaultValues) {
            let defaultVals = {notify: values?.send_notifications ?? true}
            if (allowReasonSelect && !isHug && scheduleCancelReasons && defaults?.schedule_cancel_reason_id) {
                if (scheduleCancelReasons.some(reason => reason.id === defaults?.schedule_cancel_reason_id)) {
                    defaultVals.reasonId = defaults?.schedule_cancel_reason_id ?? null
                }
            }
            setDefaultValues(defaultVals)
        }
    }, [defaults, scheduleCancelReasons, allowReasonSelect]);

    const onFieldChange = ({reasonId, notify}) => {
        if (setFieldValue) { //for now only notify value is relevant from mass action (the only flow with formik)
            setFieldValue('send_notifications', notify)
        } else {
            dispatch(updateConfirmationRes({reasonId, sendNotifications: notify}))
        }
    }

    if(!defaultValues) return <></>

    return (
        <HugimCancellation isHug={!!isHug}
                           defaultValues={defaultValues}
                           onFieldChange={onFieldChange}
                           isSingle={isSingle}
                           hideReason={!allowReasonSelect}
                           isAppointment={!!isAppointment}
        />
    );
};

export default UpdateParticipants;
